<template>
  <div>
    <!-- <div class="language-div">
      <LanguageBar />
    </div> -->
    <div class="loginWrapper">
      <div class="sliderLogin containerSingleBox">
        <div class="loginBox background-white">
          <!--Login box -->
          <div :class="['wrapper-login-companies']">
            <div class="logo">
              <img src="@/assets/images/up.png" />
              <p>{{ $t("loginTitle") }}</p>
              <p class="loginError" v-if="this.loginError != null" v-html="this.getErrorMessage()"></p>
              <p v-else><br /></p>
            </div>

            <div class="loginForm">
              <form @submit.prevent="handleSubmit">
                <input type="text" :placeholder="[[$t('userFieldLabel')]]" id="input-2" v-model="formData.username"
                  required="true" />
                <input type="password" :placeholder="[[$t('passwordFieldLabel')]]" id="input-3"
                  v-model="formData.password" required />
                <p align="right">
                  <small>
                    <router-link to="/forgot_password">
                      {{ $t("forgotPasswordLink") }}
                    </router-link>
                  </small>
                </p>
                <br />
                <input type="submit" :value="[[$t('loginButtonLabel')]]" variant="primary" class="submitCompanies" />
              </form>
              <br />
            </div>
          </div>
        </div>
      </div>
      <!--End Login box -->

    </div>
    <div id="modal_popup_help" class="modal-popup">
      <div class="modal-popup-content">
        <a @click="showModalPopup('modal_popup_help', false)" class="close-button">
          <img src="../../assets/images/close-button.svg" />
        </a>
        <p v-html="$t('customerHelpPopup')" />
      </div>
    </div>
    <!-- <modal-loading /> -->
  </div>
</template>

<script>
// import LanguageBar from "@/components/LanguageBar.vue";
import httpService from "../../http/http-common.js";
import httpServiceUser from "../../http/http-user.js";
// import utils from "@/plugins/utils.js";
// import $ from "jquery";
import Cookies from "js-cookie";
// import ModalLoading from "../../components/fragments/ModalLoading.vue";

export default {
  name: "login",
  props: {
    msg: String,
  },
  components: {
    // LanguageBar,
    // ModalLoading,
  },
  data() {
    return {
      formData: {
        username: "",
        password: "",
      },
      loginError: null,
      options: {
        expires: 10,
        sameSite: "Strict",
      },
    };
  },
  methods: {
    handleSubmit() {
      this.authorizeLogin();
    },
    async authorizeLogin() {
      // this.showModalPopup("modal_popup_loading", true);
      this.loginCustomer();
    },

    loginCustomer() {
      httpService.companyService
        .userLogin(this.formData)
        .then(function (response) {
          // handle success
          return response;
        })
        .then((response) => {
          if (response.status == 200) {
            // navigare catre aplicatia noua
            let userLink = response.headers["link"].split(";")[0];
            userLink = userLink.replace(">", "");
            userLink = userLink.replace("<", "");
            Cookies.set("userLink", userLink, {
              expires: response.data.expires_in / (24 * 60 * 60),
              sameSite: "Strict",
            });
            Cookies.set("token", response.data.access_token, {
              expires: response.data.expires_in / (24 * 60 * 60),
              sameSite: "Strict",
            });
            this.getUserInfoData(userLink, response.data.access_token);
          } else if (response.status == 400 || response.status == 403) {
            this.loginError = {
              code: response.data.error,
              description: response.data.error_description,
            };
            // this.showModalPopup("modal_popup_loading", false);
          } else {
            this.loginError = {
              code: "server_error",
              description: response.description,
            };
            // this.showModalPopup("modal_popup_loading", false);
          }
        })
        .catch((error) => {
          // handle error
          if (error.response === undefined || !error.response) {
            this.loginError = {
              code: error.response ? error.response.data.error : "500",
              description: error.response
                ? error.response.statusText
                : "server_error",
            };
          } else if (
            error.response.status == 400 ||
            error.response.status == 403
          ) {
            this.loginError = {
              code: error.response.data.error,
              description: error.response.data.error_description,
            };
          } else {
            this.loginError = {
              code: error.response ? error.response.data.error : "500",
              description: error.response
                ? error.response.statusText
                : "server_error",
            };
          }
          // this.showModalPopup("modal_popup_loading", false);
        });
    },
    showModalPopup(elementId, show) {
      if (show) {
        document.getElementById(elementId).style.visibility = "visible";
      } else {
        document.getElementById(elementId).style.visibility = "hidden";
      }
    },
    getErrorMessage() {
      if (this.loginError.description) {
        try {
          let description = JSON.parse(this.loginError.description);
          if (description) {
            let params = description[Object.keys(description)[0]];
            if (params.length > 1) {
              return this.$t("errorMessage_" + Object.keys(description)[0], {
                param: params[0],
                param1: params[1],
              });
            } else {
              return this.$t("errorMessage_" + Object.keys(description)[0], {
                param: params,
              });
            }
          } else {
            return this.$t("errorMessage_" + this.loginError.code);
          }
        } catch {
          return this.$t("errorMessage_" + this.loginError.code);
        }
      } else {
        return this.$t("errorMessage_" + this.loginError.code);
      }
    },
    getUserInfoData(userLink, token) {
      httpServiceUser.userService
        .getUserData(userLink, token)
        .then((response) => {
          Cookies.set("user_data", response.data, {
            expires: 6000000 / (24 * 60 * 60),
            sameSite: "Strict",
          });
          if (this.isUserMarketing(this.getUser())) {
            this.$router.push({
              name: "manage_offers",
            });
          }
          else {
            this.$router.push({
              name: "dashboard",
            });
          }
        });
    },
    // sendClickToGA(category, action, label) {
    //   if (this.$ga) {
    //     this.$ga.event({
    //       eventCategory: category,
    //       eventAction: action,
    //       eventLabel: label
    //     });
    //   }
    // },
  },
  mounted() {
    Cookies.remove("token");
    Cookies.remove("user");
    Cookies.remove("user_data");
    Cookies.remove('messagesCount');

  },
};
</script>
<style scoped src="@/assets/styles/login.css">

</style>
